import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 12px;
    font-family: inherit;
  }

  .refresh-btn {
    margin-bottom: 12px;
    padding: 5px 12px;
    background: #2c313a;
    color: #abb2bf;
    border: 1px solid #3e4451;
    cursor: pointer;
    font-size: 18px;
    border-radius: 3px;
    font-family: inherit;
  }

  .empty {
    color: #5c6370;
    font-size: 20px;
  }

  .inspector-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    border-bottom: 1px solid #2c313a;
  }

  .inspector-key {
    font-size: 20px;
    color: #e5c07b;
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
  }

  .start-btn {
    padding: 4px 14px;
    background: #2c313a;
    color: #528bff;
    border: 1px solid #528bff;
    border-radius: 3px;
    cursor: pointer;
    font-size: 18px;
    font-family: inherit;
    font-weight: 600;
  }

  .start-btn:hover {
    background: #3a4153;
  }
`;
